export const state = () => ({
  productsFilterMobileIsOpen: false
})

export const mutations = {
  SET_PRODUCTS_FILTER_MOBILE_IS_OPEN (state, value) {
    state.productsFilterMobileIsOpen = value
  }
}
